// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__43jsW","col":"styles_col__o_CLH","actions":"styles_actions__3BrE6","conflict":"styles_conflict__1nZMs"};